export const report = {
	title: "Relatórios",
	templateTitle: "Relatório Geral",
	search: "Buscar",
	tabs: {
		general: {
			title: "Visão geral",
			cards: {
				promoters: "Promoters",
				relationLists: "Listas",
				guests: "Convidados",
				entranceTotal: "Total em entrada",
				consumptionTotal: "Total em consumo",
				total: "Total geral",
			},
			columns: {
				listName: "Lista",
				guestName: "Nome",
				cpf: "CPF",
				promoter: "Promoter",
				entrance: "Tipo de entrada",
				upgradeEntrance: "Upgrade de entrada",
				consumption: "Consumo",
				generalTotal: "Total geral",
				checkin: "Detalhes do check-in",
				phone: "Telefone",
				birthDate: "Data de nascimento",
			},
		},
		byList: {
			title: "Por lista de convidados",
			columns: {
				relationLists: "Listas",
				promoters: "Promoters",
				guests: "Convidados",
				entranceTotal: "Total em entrada",
				consumptionTotal: "Total em consumo",
				total: "Total geral",
			},
		},
	},
	filters: {
		promoter: {
			title: "Filtrar por promoter",
			placeholder: "Adicione filtro por promoters",
		},
		relation: {
			title: "Filtrar por lista de convidados",
			placeholder: "Adicione filtros por lista",
		},
		period: "Período",
	},
	empty: {
		search: "Não encontramos resultado para a sua busca",
		filters: {
			title: "Não encontramos resultado para essa seleção",
			subtitle: "Selecione outra opção e tente novamente",
		},
		noneList: {
			title: "Parece que você não criou uma lista ainda",
			subtitle: "Os relatórios aparecerão aqui quando você tiver uma lista cadastrada",
		},
	},
	file: {
		filename: "relatorio-lista-de-convidados",
		titleByGuestList: "Relatório por lista de convidados",
		titleGeneral: "Relatório geral",
		listName: "Nome da Lista",
		promoter: "Promoter",
		numberOfActiveGuests: "Check-in realizados",
		numberOfGuests: "Total de convidado",
		entranceTotal: "Total de entrada",
		consumptionTotal: "Total em consumo",
		total: "Total geral",
		name: "Nome",
		document: "CPF",
		entranceType: "Tipo de entrada",
		upgrade: "Upgrade de entrada",
		checkinDetails: "Detalhes do check-in",
		phone: "Telefone",
		birthDate: "Data de nascimento",
	},
};
